import { useRoutes } from 'react-router-dom';

import AuthenticationRoutes from './AuthenticationRoutes';
import GuestRoutes from './GuestRoutes';
import DashboardRoutes from './DashboardRoutes';
import OverviewRoutes from './OverviewRoutes';
import AdminRoutes from './AdminRoutes';

import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export default function ThemeRoutes() {
    const credentials = useSelector((state) => state.session.credentials);
    const dashboard = useMemo(() => DashboardRoutes(credentials), [credentials]);

    return useRoutes([AdminRoutes, AuthenticationRoutes, GuestRoutes, dashboard, OverviewRoutes]);
}
